var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "health",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.245,
    height: 43.247,
    viewBox: "0 0 43.245 43.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7457",
    "data-name": "Path 7457",
    d: "M0,0H43.245V43.247H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13899",
    "data-name": "Group 13899",
    transform: "translate(1.805 3.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7458",
    "data-name": "Path 7458",
    d: "M3.367,16.418,9.21,10.574l4.957,4.957L22.22,5.464l8.31,12.465,2.27-1.514h4.721a14.437,14.437,0,0,0,.519-3.6C38.04,6.446,33.6,2,27.229,2a9.137,9.137,0,0,0-7.207,3.748A9.137,9.137,0,0,0,12.814,2C6.448,2,2,6.446,2,12.812a14.437,14.437,0,0,0,.519,3.6h.845Zm11.7,15.3L9.209,25.865,8.165,26.908A69.625,69.625,0,0,0,18.914,37.66a1.791,1.791,0,0,0,2.213,0A69.3,69.3,0,0,0,27.1,32.283l-5.678-8.517-6.362,7.953Z",
    transform: "translate(-0.199 -2.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7459",
    "data-name": "Path 7459",
    d: "M34.693,15.764l-4.361,2.906L22.758,7.31l-7.49,9.361-5.256-5.256-4.35,4.35H1v3.6H7.155l2.856-2.856,5.555,5.553,6.926-8.656,6.84,10.26,6.451-4.3h4.86v-3.6Z",
    transform: "translate(-1.002 2.256)",
    fill: "#f7901f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.278ac3207a3f316e7592cbba72654d1a.svg";
export { ForwardRef as ReactComponent };